__turbopack_context__.v({
  "className": "merriweather_ff082d9c-module__w9DJWW__className",
  "variable": "merriweather_ff082d9c-module__w9DJWW__variable",
});
